import { reactive, watch, computed } from '../dist/doux.esm'

const person = reactive({
  first: 'Bob',
  last: 'Smith'
})



watch(() => console.log(person.first))
person.first = 'Ann'
person.first = 'Haha'
person.first = 'lala'
